<div class="item-container container-fluid p-0">
  <div class="row" (click)='onSelect()'>
    <div class="doc-repo col-9">
      <div class="file-name">{{file.displayName}}</div>
      <div class="file-data">
        <span class='file-added mr-2'><strong>ADDED: </strong>{{file.createdTime | date : 'mediumDate' | uppercase}}</span>
        <!-- <span class='file-added'><strong>BY: </strong>{{file.author?.name | uppercase}}</span> -->
        </div>
    </div>

    <div class="doc-repo col-3 d-flex justify-content-between align-items-center">
      <i class="icon {{fileIconType}}"></i>
      <i 
        class="icon icon-trash text-danger ml-2"
        (click)="onDelete(file); $event.stopPropagation();"
        title="Delete file">
      </i>
    </div>
  </div>
</div>
